import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import ResponseAlert from '../../../partials/ResponseAlert'

import style from './style'

export const CommunityCreator = props => {
  return (
    <Col>
      <Row
        className={css(
          style.form.group,
          style[props.theme.name] ? style[props.theme.name].form.group : null
        )}
      >
        <Col>
          <Row>
            <Col>
              <h4 className={css(style.headers.h4)}>Details</h4>
            </Col>
          </Row>
          <RenderForm
            theme={props.theme}
            editor={props.editor}
            response={props.response}
            onChange={props.onInputChange}
            PAYMENT_TYPE={props.PAYMENT_TYPE}
            CRYPTO_TYPES={props.CRYPTO_TYPES}
          />
        </Col>
      </Row>
    </Col>
  )
}

const RenderForm = props => {
  const paymentType = props.PAYMENT_TYPE[props.editor.paymentType]
  return (
    <form className={`row`}>
      <Col xs='12'>
        {!props.response ? null : (
          <ResponseAlert
            statusCode={props.response.statusCode}
            alert={+props.response.statusCode >= 400 ? 'danger' : 'success'}
            content={props.response.data.message}
          />
        )}
      </Col>
      <Col>
        <RenderFormInput
          label={`Community Name`}
          name={`name`}
          type={`text`}
          value={props.editor.name}
          onChange={props.onChange}
          theme={props.theme}
        />
        <RenderFormInput
          label={`Motd Name`}
          name={`seo`}
          type={`text`}
          value={props.editor.seo}
          onChange={props.onChange}
          theme={props.theme}
        />
        <RenderFormInput
          label={`Community Url`}
          name={`url`}
          type={`text`}
          value={props.editor.url}
          onChange={props.onChange}
          theme={props.theme}
        />
        <RenderFormInput
          label={`Payment Type`}
          name={`paymentType`}
          type={`select`}
          value={props.editor.paymentType}
          onChange={props.onChange}
          options={props.PAYMENT_TYPE}
          theme={props.theme}
        />
        {paymentType.name !== 'crypto' ? null : (
          <RenderFormInput
            label={`Crypto Type`}
            name={`cryptoType`}
            type={`select`}
            value={props.editor.cryptoType}
            options={props.CRYPTO_TYPES}
            onChange={props.onChange}
            theme={props.theme}
          />
        )}
        <RenderFormInput
          label={
            paymentType.name !== 'crypto' ? `Payment Address` : `Crypto Address`
          }
          name={`paymentAddress`}
          type={`text`}
          value={paymentType.address ? props.editor.paymentAddress : ''}
          placeholder={paymentType.comment || ''}
          onChange={props.onChange}
          theme={props.theme}
          disabled={!paymentType.address}
        />
      </Col>
    </form>
  )
}

const RenderFormInput = props => {
  return (
    <Row
      className={css(
        style.form.inputGroup,
        style[props.theme.name] ? style[props.theme.name].form.inputGroup : null
      )}
    >
      <Col xs='auto' />
      <Col xs='12' lg='3' className={`d-flex align-items-center`}>
        <span>{props.label || props.name}</span>
      </Col>
      <Col>
        {props.type === 'text' ? (
          <input
            tyle={`text`}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
            disabled={props.disabled}
            className={css(
              style.form.input,
              style[props.theme.name]
                ? style[props.theme.name].form.input
                : null
            )}
          />
        ) : (
          <select
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            className={css(
              style.form.input,
              style.form.select,
              style[props.theme.name]
                ? style[props.theme.name].form.input
                : null
            )}
          >
            {props.options.map((option, index) => (
              <option value={index} key={index}>
                {option.label || option.name}
              </option>
            ))}
          </select>
        )}
      </Col>
    </Row>
  )
}

export default CommunityCreator



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityCreator/index.js